import type { TenantConfig } from '@/types/TenantConfig'

const darkBlue = '#0A1436'
const lightBlue = '#A6BCFC'

export const xperiaupclose: TenantConfig = {
  logo: 'assets/xperiaupclose/static/logo2.svg',
  teaserImageSize: {
    width: 320,
  },
  themeOptions: {
    primaryColor: darkBlue,
    secondaryColor: lightBlue,
    logoHeight: '60px',
    headerHeight: '90px',
    headerBottomBorder: '1px solid #000000',
    footerBackgroundColor: '#000000',
    footerTextColor: 'white',
  },
}
